/**
 * The Description a document starts with when it is made FROM another one (a purchase order from a change order / selection / warranty, a bill from a
 * purchase order...): the source's identifier on the first line, prefixed with its type, its own Description underneath. Only an INITIAL value - the new
 * document's Description is edited like any other and never rewritten.
 *
 *   line 1  "<Type>: <title>" ("Selection: Quartz"); a source without a title is named by its number ("Purchase Order: PO000007")
 *   line 2  the source's Description, when it has one
 *
 * No "undefined" / "null", no blank lines, and nothing is repeated: a title that already starts with "<Type>:" is not prefixed again, and a Description that
 * already starts with the first line is not preceded by it twice.
 * (backend/modules/cost-management/derived-description.js applies the same rule on the server, for a request that comes without a Description.)
 */
export interface DescriptionSource {
  /** "Change Order", "Selection", "Purchase Order", "Warranty" */
  type: string;
  /** the visible number ("CO000001") - names the source when it has no title */
  number?: string | null;
  title?: string | null;
  description?: string | null;
}

const clean = (value: unknown): string => (value === null || value === undefined ? '' : String(value).trim());

export function derivedDescription(source: DescriptionSource): string {
  const type = clean(source.type);
  const ident = clean(source.title) || clean(source.number);
  const body = clean(source.description);
  const prefixed = type && ident.toLowerCase().startsWith(`${type.toLowerCase()}:`);
  const head = !ident ? '' : prefixed || !type ? ident : `${type}: ${ident}`;
  if (!head) return body;
  if (!body) return head;
  return body.toLowerCase().startsWith(head.toLowerCase()) ? body : `${head}\n${body}`;
}
